import VpnKeyIcon from '@material-ui/icons/VpnKey';
import React from 'react';
import { TextInput, TextInputProps } from '~ui-kit/components/text-input';
import { BaseFormField, BaseFormFieldProps } from './base-form-field';

export interface PasswordFormFieldProps extends BaseFormFieldProps, TextInputProps {
  name: string;
}

export function PasswordFormField({
  name,
  showErrorOnBlur,
  helperText,
  variant = 'outlined',
  startIcon = <VpnKeyIcon />,
  ...rest
}: PasswordFormFieldProps) {
  return (
    <BaseFormField name={name} showErrorOnBlur={showErrorOnBlur}>
      {(showErrorState, field) => {
        const { input, meta } = field;

        return (
          <TextInput
            type="password"
            name={name}
            helperText={(showErrorState && meta.error) || helperText}
            error={showErrorState}
            variant={variant}
            startIcon={startIcon}
            margin="none"
            {...input}
            {...rest}
          />
        );
      }}
    </BaseFormField>
  );
}
